import { useEffect, useRef, useState } from "react";
import { Check, Copy } from "lucide-react";
import { copiaTesto } from "@/lib/copiaTesto";

/**
 * "Copia" su una domanda o su una risposta (Davide, 04/09/2026).
 *
 * In cantiere la risposta si gira al collega su WhatsApp, o si incolla nel
 * rapporto di intervento: finora l'unica via era selezionare a mano dentro una
 * bolla, che sul telefono e' un esercizio di pazienza.
 *
 * La conferma e' il segno di spunta sul bottone stesso, per un paio di secondi:
 * un avviso a comparsa per un gesto cosi' piccolo sarebbe rumore, e sopra la
 * tastiera aperta coprirebbe proprio quello che si sta leggendo.
 */
export function BottoneCopia({
  testo,
  etichetta = "Copia",
  className = "",
}: {
  testo: string;
  /** Cosa si sta copiando: finisce nel titolo e nella voce per i lettori di schermo. */
  etichetta?: string;
  className?: string;
}) {
  const [fatto, setFatto] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  // se il messaggio sparisce mentre il segno di spunta e' acceso, il timer
  // non deve svegliarsi su un componente che non c'e' piu'
  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);

  const copia = async () => {
    const ok = await copiaTesto(testo);
    if (!ok) return;
    setFatto(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setFatto(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={copia}
      title={etichetta}
      aria-label={etichetta}
      className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-md text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      {fatto ? (
        <Check size={16} className="text-emerald-600 dark:text-emerald-400" />
      ) : (
        <Copy size={16} />
      )}
      <span className="sr-only" aria-live="polite">
        {fatto ? "Copiato" : ""}
      </span>
    </button>
  );
}
